import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'smartCurrency'
})
export class SmartCurrencyPipe implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe) {}

  transform(
    value: number | null | undefined,
    currency: string = 'USD',
    fbValue = '',
    display = 'symbol',
    digits = null,
    showZero = false): string {
    if (value === null || value === undefined || (!showZero && value === 0)) {
      return fbValue;
    }

    const fractionDigits = value % 1 === 0 ? 0 : 2;

    digits = digits ?? `1.${fractionDigits}-${fractionDigits}`

    return this.currencyPipe.transform(value, currency, display, digits) || '';
  }
}
